import Slide from './slide'
import VideoSlide from './video_slide'

export default class SlideController {
  get currentSlide () {
    return this.slides[this.currentSlideIndex]
  }

  constructor (slidesData, options, currentSlideIndex, errorCallback) {
    this.currentSlideIndex = currentSlideIndex
    this.errorCallback = errorCallback
    this.numberOfSlides = 0
    this.data = slidesData
    this.options = options

    this.setup()
  }

  setup () {
    this.slides = this.data.map((item, index) => {
      if (typeof item.video === 'string') {
        return new VideoSlide(item, index + 1, this.options, this.slideError.bind(this))
      }

      return new Slide(item, index + 1, this.options, this.slideError.bind(this))
    })

    this.numberOfSlides = this.slides.length

    this.copySlidesIfNeeded()
  }

  copySlidesIfNeeded () {
    if (this.slides.length && this.slides.length < 3) {
      const slideCopies = this.slides.map((s) => s.copy())
      this.slides = this.slides.concat(slideCopies)

      this.copySlidesIfNeeded()
    }
  }

  slideError () {
    let dataModified = false

    this.slides.forEach(slide => {
      if (slide.errored && this.data[slide.number - 1]) {
        this.data.splice((slide.number - 1), 1)
        dataModified = true
      }
    })

    if (dataModified) {
      this.setup()
      this.errorCallback()
    }
  }

  nextSlideIndex (slideIndex) {
    return slideIndex === (this.slides.length - 1) ? 0 : (slideIndex + 1)
  }

  prevSlideIndex (slideIndex) {
    return slideIndex === 0 ? (this.slides.length - 1) : (slideIndex - 1)
  }

  nextSlide () {
    this.currentSlide.blur()
    this.currentSlideIndex = this.nextSlideIndex(this.currentSlideIndex)
  }

  prevSlide () {
    this.currentSlide.blur()
    this.currentSlideIndex = this.prevSlideIndex(this.currentSlideIndex)
  }

  jumpToSlide (slideIndex) {
    this.currentSlide.blur()
    this.currentSlideIndex = slideIndex
  }

  stop () {
    this.currentSlide.stop()
  }

  activeSlidesIndexes () {
    const indexes = [this.currentSlideIndex]

    // growLeft
    const slideToLeftIndex = this.prevSlideIndex(indexes[0])
    indexes.unshift(slideToLeftIndex)

    // growRight
    const slideToRightIndex = this.nextSlideIndex(indexes[indexes.length - 1])
    indexes.push(slideToRightIndex)

    return indexes
  }
}
